import { useContext } from 'react';
//
import { AuthContext } from 'src/contexts/EmployeeJWTContext';

// ----------------------------------------------------------------------

const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) throw new Error('Employee Auth context must be use inside Employee AuthProvider');

  return context;
};

export default useAuth;
